import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { FadeScrollWrapper, ICONS, ScrollBar } from '@app/styles';
import { Component_EntityTimestamps } from '@app/styles/frontend/ui/components/Component_EntityTimestamps/Component_EntityTimestamps';
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { ConfigKeyFE_DPViewOrder, ModuleFE_DiseaseProfile, ModuleFE_DiseaseView, ModuleFE_MultiVar } from '../../../../../_entity.js';
import { asArray, dbObjectToId, exists, sortArray } from '@nu-art/ts-common';
import { getDiseaseProfileTimestamps } from '../../../../../utils/disease-profile-timestamps.js';
import { createRef } from 'react';
import './Panel_DiseaseViews.scss';
import { noDiseaseViewId } from '../../consts.js';
export class Panel_DiseaseViews extends ComponentSync {
    scrollRef = createRef();
    // ######################## Life Cycle ########################
    __onMultiVarUpdated = (...params) => {
        if (asArray(params[1]).some(mv => mv.diseaseProfileId === this.state.renderArgs.itemId))
            this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        state.tabId = nextProps.tabId;
        state.relatedMultiVarMap = this.calculateRelatedMultiVars(state.renderArgs.itemId);
        return state;
    }
    // ######################## Logic ########################
    calculateRelatedMultiVars(diseaseProfileId) {
        const multiVars = ModuleFE_MultiVar.cache.filter(mv => mv.diseaseProfileId === diseaseProfileId);
        const mappedMVIds = new Set();
        const map = ModuleFE_DiseaseView.cache.all().reduce((map, dv) => {
            map[dv._id] = multiVars.filter(mv => ModuleFE_DiseaseView.filterMultiVarByEnforcedTag(dv, mv)).map(dbObjectToId);
            map[dv._id].forEach(id => mappedMVIds.add(id));
            return map;
        }, {});
        map[noDiseaseViewId] = multiVars.filter(mv => !mappedMVIds.has(mv._id)).map(dbObjectToId);
        return map;
    }
    clearSelectedMultiVar = () => {
        const currentSelectedMVId = this.state.renderArgs.multiVar.id;
        if (!currentSelectedMVId)
            return;
        const newArgs = { ...this.state.renderArgs.multiVar, id: undefined };
        this.props.workHubItem.updateArgs(this.state.tabId, { multiVar: newArgs });
    };
    selectDiseaseView = (dvId) => {
        if (dvId === this.state.renderArgs.profile.selectedDiseaseViewId)
            return;
        const args = { ...this.state.renderArgs.profile, selectedDiseaseViewId: dvId };
        this.props.workHubItem.updateArgs(this.state.tabId, { profile: args });
    };
    getDiseaseViews = () => {
        const allDVs = ModuleFE_DiseaseView.cache.allMutable();
        const sortConfig = ConfigKeyFE_DPViewOrder.get();
        return sortArray(allDVs, dv => sortConfig.indexOf(dv._id));
    };
    // ######################## Render ########################
    render() {
        const diseaseViews = this.getDiseaseViews();
        return _jsxs(LL_H_C, { className: 'panel__disease-views', children: [_jsxs(LL_V_L, { className: 'panel__disease-views__content', children: [this.render_Header(), _jsxs(FadeScrollWrapper, { scrollRef: this.scrollRef, children: [this.render_NoDiseaseView(), diseaseViews.map(this.render_DiseaseView)] })] }), _jsx(ScrollBar, { scrollableRef: this.scrollRef })] });
    }
    render_Header = () => {
        const diseaseProfile = ModuleFE_DiseaseProfile.cache.unique(this.state.renderArgs.itemId);
        const selectedMVId = this.state.renderArgs.multiVar.id;
        const timestamps = getDiseaseProfileTimestamps(this.state.renderArgs.itemId);
        return _jsxs(LL_H_C, { className: 'panel__disease-views__header', children: [_jsxs(LL_H_C, { className: 'panel__disease-views__title-group', children: [_jsx("div", { className: 'panel__disease-views__title', children: diseaseProfile?.label ?? 'N/A' }), _jsx(ICONS.information.component, { className: _className(!selectedMVId && 'active'), onClick: this.clearSelectedMultiVar })] }), exists(timestamps) && _jsx(Component_EntityTimestamps, { className: 'panel__disease-views__timestamps', ...timestamps })] });
    };
    render_DiseaseView = (dv) => {
        const relatedMVs = this.state.relatedMultiVarMap[dv._id];
        const className = _className('panel__disease-views__view', dv._id === this.state.renderArgs.profile.selectedDiseaseViewId && 'selected');
        return _jsxs(LL_H_C, { className: className, onClick: () => this.selectDiseaseView(dv._id), children: [_jsx("div", { className: 'view-label', children: dv.label }), !!relatedMVs.length && _jsx("div", { className: 'mv-count', children: relatedMVs.length })] }, dv._id);
    };
    render_NoDiseaseView = () => {
        const relatedMVs = this.state.relatedMultiVarMap[noDiseaseViewId];
        if (!relatedMVs.length)
            return;
        const className = _className('panel__disease-views__view no-view', this.state.renderArgs.profile.selectedDiseaseViewId === noDiseaseViewId && 'selected');
        return _jsxs(LL_H_C, { className: className, onClick: () => this.selectDiseaseView(noDiseaseViewId), children: [_jsx("div", { className: 'view-label', children: "No Matching Disease View" }), !!relatedMVs.length && _jsx("div", { className: 'mv-count', children: relatedMVs.length })] });
    };
}
//# sourceMappingURL=Panel_DiseaseViews.js.map